import moment from 'moment';

import { FORTA_BLUE, FORTA_SUCCESS, FORTA_YELLOW } from '../../../utils/colors';
import { ServiceCodeTypes } from '../billings/claim-info/enum';
import { TreatmentPlanStatus } from './constants/general';

import type { IClientPolicyMap, IServiceCodeDescription } from '../../../utils/types';

interface TreatmentPlanStatusInfo {
  color: string;
  text: string;
  signatureNeeded: boolean;
}

export const getTreatmentPlanStatus = (
  treatmentPlan: any,
  tpStatusIdByLabel: any,
): TreatmentPlanStatusInfo => {
  if (!treatmentPlan || !tpStatusIdByLabel) {
    return {
      color: '',
      text: '',
      signatureNeeded: false,
    };
  }

  switch (treatmentPlan?.status_id) {
    case tpStatusIdByLabel[TreatmentPlanStatus.Started]:
      return {
        color: FORTA_BLUE.bright,
        text: 'In progress',
        signatureNeeded: true,
      };
    case tpStatusIdByLabel[TreatmentPlanStatus.Editing]:
      return {
        color: FORTA_YELLOW,
        text: 'Editing',
        signatureNeeded: true,
      };
    case tpStatusIdByLabel[TreatmentPlanStatus.Completed]:
      return {
        color: FORTA_SUCCESS,
        text: 'Completed',
        signatureNeeded: false,
      };
    case tpStatusIdByLabel[TreatmentPlanStatus.Readonly]:
      return {
        color: FORTA_BLUE.dark,
        text: 'Historical TP',
        signatureNeeded: false,
      };
    default:
      return {
        color: '',
        text: '',
        signatureNeeded: false,
      };
  }
};

export const getServiceName = (
  service: any,
  preferredServiceCodeType: ServiceCodeTypes | null,
  serviceCodeLabels: IServiceCodeDescription[],
) => {
  if (!service) return '';
  const serviceLabel = serviceCodeLabels.find((label) => label.service_code === service.code);
  if (preferredServiceCodeType === ServiceCodeTypes.Hcpcs) {
    return `${service.hcpcsCode} ${
      serviceLabel?.description || service.name.replace(service.code, '')
    }`;
  } else {
    return `${service.code} ${serviceLabel?.description || service.name.replace(service.code, '')}`;
  }
};

export const getActivePrimaryPolicy = (
  policies: IClientPolicyMap[],
  date: moment.Moment | null,
  currentDate: moment.Moment,
): IClientPolicyMap | null => {
  return (
    policies.find(({ payor_responsibility, date_start, date_end }) => {
      if (payor_responsibility !== 'PRIMARY') return false; //  only return primary policies

      const policyStart = moment(date_start);
      const policyEnd = date_end ? moment(date_end) : null;

      if (date) {
        return policyStart.isSameOrBefore(date) && (!policyEnd || policyEnd.isSameOrAfter(date)); //  return policies that are active on the given date
      }
      return (
        policyStart.isSameOrBefore(currentDate) &&
        (!policyEnd || policyEnd.isSameOrAfter(currentDate)) //  return policies that are active on the current date
      );
    }) || null //  return null if no policy is found
  );
};
